import { Box, FilledInput } from "@material-ui/core";

const InputBox = (props) => {
  const { value, onChange, multiline, rows, placeholder } = props;
  return (
    <Box
      paddingLeft="0.75rem"
      paddingRight="0.75rem"
      component={FilledInput}
      multiline={multiline}
      rows={rows}
      defaultValue={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
    />
  );
};

export default InputBox;
